import { render, staticRenderFns } from "./modeltree.vue?vue&type=template&id=315a14a7&scoped=true"
import script from "./modeltree.vue?vue&type=script&lang=js"
export * from "./modeltree.vue?vue&type=script&lang=js"
import style0 from "./modeltree.vue?vue&type=style&index=0&id=315a14a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315a14a7",
  null
  
)

export default component.exports